<template>
    <div class="row">
        <div class="col-md-auto">
            <v-picture-cropper placeholder="Firma Logosu" :picture="value.Logo"
                v-on:change="value.Logo = $event"></v-picture-cropper>
        </div>
        <div class="col-md">
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label">Ana Firma</label>
                    <v-select-list :options="parentFirms" :disabled="editing" v-model="parentFirm"
                        placeholder="Ana Firma" label="FirmInformation"></v-select-list>
                </div>
                <div class="col-md-6 mb-1">
                    <label class="form-label">İsim</label>
                    <input type="text" class="form-control" placeholder="İsim" v-model="value.Name" />
                </div>
                <div class="col-md-6 mb-1">
                    <label class="form-label">Kısa İsim</label>
                    <input type="text" class="form-control" placeholder="Kısa İsim" v-model="value.FirmShortName" />
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Sektör</label>
                    <v-select-list v-model="sector" multiple label="Name" placeholder="Sektör" :options="sectors" />
                </div>
                
                <div class="col-md-12 mb-1">
                    <div class="row p-0">

                        <div class="col-md-5">
                            <div class="radio-wrapper-bg d-flex justify-content-between align-items-center">
                                <label class="form-label m-0 p-0 mr-1" style="font-size: 14px;">Tip</label>
                                <div class="btn-group btn-group-toggle flex-nowrap" data-toggle="buttons">
                                    <b-form-radio inline v-model="value.IsCompany" :value="true">Şirket</b-form-radio>
                                    <b-form-radio inline v-model="value.IsCompany" :value="false">Şahıs</b-form-radio>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-7">
                            <div class="radio-wrapper-bg d-flex justify-content-between align-items-center">
                                <label class="form-label m-0 p-0 mr-1" style="font-size: 14px;">Yakıt Tedarikçisi
                                </label>
                                <div class="btn-group btn-group-toggle flex-nowrap" data-toggle="buttons">
                                    <b-form-radio inline v-model="value.FirmRole" value="1" @change="$forceUpdate()" >Hayır</b-form-radio>
                                    <b-form-radio inline v-model="value.FirmRole" value="5" @change="$forceUpdate()" >Evet</b-form-radio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mb-1">
                    <label class="form-label">Vergi Dairesi</label>
                    <v-select-list v-model="taxAdministration" label="Name" placeholder="Vergi Dairesi"
                        :options="taxAdministrations" />
                </div>
                <div class="col-lg-12">
                    <div class="row align-items-start">
                        <div class="col">
                            <label class="form-label">{{ value.IsCompany ? "Vergi Numarası" : "Kimlik Numarası"}}</label>
                            <input type="text" class="form-control"
                                :placeholder="value.IsCompany ? 'Vergi Numarası' : 'Kimlik Numarası'"
                                v-model="value.TaxNumber" />
                        </div>
                        <div class="col-auto my-auto">
                            <button v-on:click="checkTaxNumber(value.TaxNumber)" class="btn btn-success btn-icon">
                                <b-spinner small v-if="checkTaxNumberLoading"></b-spinner>
                                <feather-icon v-else icon="SearchIcon"></feather-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <b-form-checkbox v-model="value.IsOwnFirm" style="margin-top: 2px;"><strong>{{ companyName
                    }}</strong> Firmasına Ait</b-form-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import VPictureCropper from '@/components/VPictureCropper.vue'
import Auth from '@/utilities/auth'
import { BFormCheckbox, BFormRadio, BSpinner } from 'bootstrap-vue'
import FirmOperationsApi from '@/api/firm-operations'

export default {
    components: {
        VPictureCropper,
        BFormCheckbox,
        BFormRadio,
        BSpinner,
    },
    props: {
        value: Object,
        editing: Boolean
    },
    data() {
        return {
            sectors: [],
            taxAdministrations: [],
            parentFirms: [],
            checkTaxNumberLoading: false
        }
    },
    mounted() {
        this.getSectors()
        this.getTaxAdministrations()
        this.getParentFirms()
    },
    methods: {
        getSectors() {
            SystemDataApi.Sector().then((res) => {
                this.sectors = res.data.Data
            })
        },
        getTaxAdministrations() {
            SystemDataApi.TaxAdministrationList().then((res) => {
                this.taxAdministrations = res.data.Data
            })
        },
        getParentFirms() {
            FirmOperationsApi.ParentFirm.List().then(res => {
                this.parentFirms = res.data.Data
            })
        },
        checkTaxNumber(data) {
            this.checkTaxNumberLoading = true
            FirmOperationsApi.CheckTaxNumber(data).then(res => {
                this.checkTaxNumberLoading = false
                this.$result(res)
            }).catch(err => {
                this.$result(null, err)
                this.checkTaxNumberLoading = false
            })
        }
    },
    computed: {
        sector: {
            get: function () {
                return this.sectors.filter(b => this.value.SectorTypeIds.includes(b.Id))
            },
            set: function (value) {
                this.value.SectorTypeIds = value?.map(b => b.Id) || []
            }
        },
        taxAdministration: {
            get: function () {
                return this.taxAdministrations.find(b => b.Id == this.value.TaxAdministrationId)
            },
            set: function (value) {
                this.value.TaxAdministrationId = value?.Id || null
            }
        },
        parentFirm: {
            get: function () {
                return this.parentFirms.find(b => b.Id == this.value.ParentFirmId)
            },
            set: function (value) {
                this.value.ParentFirmId = value?.Id || null
            }
        },
        companyName() {
            return Auth.companyName
        }
    }
}
</script>

<style lang="css" scoped>
.radio-wrapper-bg {
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    padding: 9px;
}
</style>